module.exports = __webpack_public_path__ + "static/media/19.4f554a0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/lhand/19.png
// module id = 759
// module chunks = 0